import { Component } from '@angular/core';
import { AuthService } from '../../../services/auth/auth.service';
import { Router } from '@angular/router';
import { ApplicantsService } from '../../../services/http/applicants/applicants.service';

@Component({
  selector: 'app-login-redirect-private',
  standalone: true,
  imports: [],
  templateUrl: './login-redirect-private.component.html',
  styleUrl: './login-redirect-private.component.scss'
})
export class LoginRedirectPrivateComponent {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly applicantService: ApplicantsService
  ) {
    this.setUser();
  }

  async setUser() {
    const valid = await this.authService.setUser(true);
    if (valid) {
      switch (this.authService.getCurrentUser().rol) {
        case 'public':
          this.authService.logoutUser();
          break;
        case 'level1':
          this.router.navigate(['/requests']);
          break;
        case 'level2':
          this.router.navigate(['/requests']);
          break;
        case 'administrator':
          this.router.navigate(['/requests']);
          break;
        default:
          this.router.navigate(['/login']);
          break;
      }
    } else {
      this.authService.logoutUser();
      this.router.navigate(['/login']);
    }
  }
}
